import Decimal from './break_infinity';
import {html} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import {Panel} from './panel';
import {ri, tickLength} from './runner-idle';
import {formatTime} from './utils';
import {of} from 'rxjs';

@customElement('ri-speed-controls')
export class SpeedControls extends Panel {
  override name = 'Speed Controls';
  override subtitle = '';
  override id = 'speed-controls';
  @state() tick: Decimal = new Decimal(0);

  override setup() {
    super.setup();
    this.subscribe('tick', ri.tick$);
  }
  override render() {
    return super.render(html`
      <div class="flex-horizontal">
        <div
          id="speed-select"
          @click=${(event: Event) => {
            const target = event.composedPath()[0];
            if (
              !(
                target instanceof HTMLElement &&
                target.hasAttribute('data-value')
              )
            )
              return;
            ri.gameSpeed = Number(target.getAttribute('data-value'));
            if (ri.gameSpeed === 0) {
              ri.masonryRoot?.classList.add('paused');
            } else {
              ri.masonryRoot?.classList.remove('paused');
            }
            ri.requestUpdate();
            this.requestUpdate();
          }}
        >
          <button
            class="speed-select-item ${ri.gameSpeed == 0 ? 'selected' : ''}"
            data-value=${0}
          >
            ⏸
          </button>
          <button
            class="speed-select-item ${ri.gameSpeed == 1 ? 'selected' : ''}"
            data-value=${1}
          >
            ▶
          </button>
          <!-- <button
                class="speed-select-item ${ri.gameSpeed == 2 ? 'selected' : ''}"
                data-value=${2}
              >
                ▶▶
              </button> -->
          <button
            class="speed-select-item"
            ?disabled=${ri.gameSpeed != 0}
            @click=${() => {
              if (!ri.steppingOneFrame) {
                ri.steppingOneFrame = true;
                ri.gameSpeed = 1;
                ri.requestUpdate();
              }
            }}
          >
            ▶|
          </button>
        </div>
        ${formatTime(this.tick.times(tickLength / 1000))}
        <input
          type="checkbox"
          class="filter"
          id="use-saved-time"
          @change=${(event: Event) => {
            if (!(event.target instanceof HTMLInputElement)) return;
            ri.useSavedTime = event.target.checked;
            ri.gameSpeed$.next(ri.gameSpeed);
          }}
        /><label
          class="chip"
          id="use-saved-time-toggle"
          hidden
          for="use-saved-time"
          >Use Saved Time: ${formatTime(ri.resources.time.value.floor())}</label
        >
      </div>
    `);
  }
}
